import { render, staticRenderFns } from "./dollar-sign-icon-new.vue?vue&type=template&id=54a0fd4d&scoped=true&"
import script from "./dollar-sign-icon-new.vue?vue&type=script&lang=js&"
export * from "./dollar-sign-icon-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a0fd4d",
  null
  
)

export default component.exports